<script lang="ts" setup>
	import dayjs from 'dayjs'
	import type { TravelPendingPolicyResponse } from '~/types'

	const props = defineProps<{
		records: TravelPendingPolicyResponse['pendingPolicies']
		recordColumn?: TableColumn
		actionBtnText?: string
		status?: string
		isLoading?: boolean
	}>()

	const { currencyToNaira } = useCurrency()
	const custodianRecord = computed(() => props.records.map((item, i) => ({ ...item, ...item.meta, key: i })))

	const {
		policiesTableColumn: { travel }
	} = useProducts()

	const emits = defineEmits<{
		(event: 'change', param: RecordSchema): void
	}>()

	const getStaff = (arg: RecordSchema) => {
		emits('change', arg)
	}
</script>

<template>
	<div>
		<shared-table-loader v-slot="{ columns }" :loading="isLoading" :columns="recordColumn || travel">
			<a-table :columns="columns" :data-source="custodianRecord">
				<template #bodyCell="{ column, record, index }">
					<span v-if="column.dataIndex === 'sn'">{{ index + 1 }}</span>

					<span v-if="column.dataIndex === 'location_name'">{{
						record?.location_name || record?.destination
					}}</span>
					<span v-if="column.dataIndex === 'end_date'">{{
						dayjs(record?.end_date || record?.arrival_date).format('DD/MM/YYYY')
					}}</span>
					<span v-if="column.dataIndex === 'start_date'">{{
						dayjs(record?.start_date || record?.departure_date).format('DD/MM/YYYY')
					}}</span>
					<span v-if="column.dataIndex === 'value'">{{ currencyToNaira(record?.value) }}</span>
					<span v-if="column.dataIndex === 'custodian'">
						{{ record?.first_name || record?.meta?.first_name }}
						{{ record?.last_name || record?.meta?.last_name }}
					</span>

					<my-cover-plan-status v-if="column.key === 'status'" :plan-details="record || null" />

					<button
						v-if="column.dataIndex === 'details'"
						type="button"
						aria-label="activate staff"
						aria-roledescription="view beneficiary plan details"
						class="text-sm font-medium"
						@click="getStaff(record)"
					>
						<span class="font-medium text-primary-2"> {{ actionBtnText || 'Activate' }} </span>
					</button>
				</template>
			</a-table>
		</shared-table-loader>
	</div>
</template>
